module.exports = __webpack_public_path__ + "static/media/fpl_home.c38afa82.png";